/* eslint-disable react-hooks/exhaustive-deps */
import { Add, AddAPhoto } from "@mui/icons-material";
import {
  Autocomplete,
  Chip,
  FormControl,
  Grid,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { FiTrash, FiTrash2 } from "react-icons/fi";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { uploadFile } from "../../../../../../api/order";
import InputField from "../../../../../../Authentication/components/InputField";
import { orderSelector } from "../../../../../../redux/slices/orderSlice";
import {
  getProductDetailsForUpdate,
  productSelector,
} from "../../../../../../redux/slices/productSlice";
import { deleteImage } from "../../utils/deleteItem";

export default function MultipleVariantAddForm({
  variants,
  setVariants,
  title,
  setTitle,
  sku,
  setSKU,
  setFileLink,
  productType,
  setProductType,
}) {
  const { imageList, productInfo, updateProductDetails } =
    useSelector(productSelector);
  const { uploadedMediaFile } = useSelector(orderSelector);
  const [previewImage, setPreviewImage] = useState(null);
  const [previewSizingTable, setPreviewSizingTable] = useState(null);
  const [sizingTableFileLink, setSizingTableFileLink] = useState(null);
  const [isAdd, setIsAdd] = useState(false);
  const dispatch = useDispatch();

  const params = useParams();
  const savedProduct = productInfo?.products?.find(
    (product) => product._id === params.id
  );

  const [optionNames, setOptionNames] = useState(
    savedProduct?.variant_options || []
  );

  const deleteVariant = (option) => {
    const findVariants = variants?.find((variant) => variant.option === option);
    const findOptions = optionNames.find(
      (variant) => variant.option === option
    );

    if (findOptions) {
      const filteredOptions = [...optionNames];
      const index = filteredOptions.indexOf(findOptions);
      if (index > -1) {
        filteredOptions.splice(index, 1);
      }
      setOptionNames(filteredOptions);
    }

    if (findVariants) {
      const filteredVariants = [...variants];
      const index = filteredVariants.indexOf(findVariants);
      if (index > -1) {
        filteredVariants.splice(index, 1);
      }
      setVariants(filteredVariants);
    }
  };

  const getVariants = (item) => {
    const find = variants?.find((variant) => variant.option === item.option);

    if (!find) {
      setVariants([...variants, item]);
    } else {
      const filteredVariants = [...variants];
      const index = filteredVariants.indexOf(find);
      if (index > -1) {
        filteredVariants[index] = item;
      }
      setVariants(filteredVariants);
    }
  };

  const uploadMedia = () => {
    const formData = new FormData();
    formData.append("media", sizingTableFileLink);
    dispatch(uploadFile(formData));
  };

  useEffect(() => {
    if (sizingTableFileLink) {
      uploadMedia();
    }
  }, [sizingTableFileLink]);

  useEffect(() => {
    if (uploadedMediaFile?.media && sizingTableFileLink) {
      dispatch(
        getProductDetailsForUpdate({
          ...updateProductDetails,
          sizing_table: uploadedMediaFile?.media,
        })
      );
      setSizingTableFileLink(null);
    }
  }, [dispatch, uploadedMediaFile?.media]);

  return (
    <div>
      <Grid container spacing={4}>
        <Grid item xs={3.5}>
          {previewImage && (
            <div style={{ position: "relative" }}>
              <img
                src={previewImage}
                alt="sdfsd"
                style={{
                  maxHeight: "410px",
                  width: "100%",
                  borderRadius: "8px",
                }}
              />
              <div style={{ position: "absolute", top: "10px", right: "10px" }}>
                <IconButton
                  style={{ color: "white" }}
                  onChange={(e) => {
                    setFileLink(e.target.files[0]);
                    setPreviewImage(URL.createObjectURL(e.target.files[0]));
                  }}
                  //   color="primary"
                  aria-label="upload picture"
                  component="label"
                  // sx={{ position: "absolute", bottom: 10, right: 10 }}
                >
                  <input hidden accept="image/*" type="file" />
                  <AddAPhoto sx={{ fontSize: "40px" }} />
                  {/* <Icon icon="bi:cloud-upload" width="40" height="40" /> */}
                </IconButton>
              </div>
            </div>
          )}
          {!previewImage && (
            <div
              style={{
                height: "410px",
                border: "1px dashed lightgray",
                padding: "26px",
                borderRadius: "5px",
                display: "grid",
                placeItems: "center",
                // textAlign: "center",
              }}
            >
              <IconButton
                onChange={(e) => {
                  setFileLink(e.target.files[0]);
                  setPreviewImage(URL.createObjectURL(e.target.files[0]));
                }}
                //   color="primary"
                aria-label="upload picture"
                component="label"
                // sx={{ position: "absolute", bottom: 10, right: 10 }}
              >
                <input hidden accept="image/*" type="file" />
                <AddAPhoto sx={{ fontSize: "40px" }} />
                {/* <Icon icon="bi:cloud-upload" width="40" height="40" /> */}
              </IconButton>
            </div>
          )}
          <div
            style={{
              width: "100%",
              display: "flex",
              flexWrap: "wrap",
              marginTop: "10px",
            }}
          >
            {imageList?.map((image) => (
              <div
                style={{
                  width: "21%",
                  margin: "2%",
                  padding: "10px",
                  border: "1px solid #eee",
                  borderRadius: "5px",
                  position: "relative",
                }}
              >
                <img src={image.src} alt="media" style={{ width: "100%" }} />
                <FiTrash2
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "10px",
                    color: "lightgray",
                    fontSize: "20px",
                    cursor: "pointer",
                  }}
                  onClick={() => {
                    deleteImage(image, imageList);
                    setPreviewImage(null);
                  }}
                />
              </div>
            ))}
            {/* <InputLabel>Upload Sizing Table</InputLabel> */}
          </div>
        </Grid>
        <Grid item xs={8.5}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              <InputLabel sx={{ margin: 0, textAlign: "left", color: "#000" }}>
                Product Title
              </InputLabel>
              <InputField
                placeholder="Enter product title"
                type="text"
                size="small"
                name="title"
                defaultValue={savedProduct?.title || title}
                onChange={(e) => setTitle(e.target.value)}
              />
            </Grid>
            <Grid item xs={4}>
              <InputLabel>Product Type</InputLabel>
              <FormControl fullWidth>
                <Select
                  displayEmpty
                  sx={{
                    margin: "10px 0",
                    width: "auto",
                    height: "46px",
                    textAlign: "left",
                  }}
                  value={productType || "Select product type"}
                  onChange={(e) => setProductType(e.target.value)}
                >
                  <MenuItem disabled value="Select product type" selected>
                    Select product type
                  </MenuItem>
                  <MenuItem value="non_electric_regular">Non electric</MenuItem>
                  <MenuItem value="liquid_regular">Liquid regular</MenuItem>
                  <MenuItem value="electric_regular">Electric regular</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={4}>
              <InputLabel sx={{ margin: 0, textAlign: "left", color: "#000" }}>
                Product SKU
              </InputLabel>
              <InputField
                placeholder="Enter product sku"
                type="text"
                size="small"
                name="sku"
                defaultValue={sku || savedProduct?.sku}
                onChange={(e) => setSKU(e.target.value)}
              />
            </Grid>
            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={8}>
                  <InputLabel
                    sx={{ margin: 0, textAlign: "left", color: "#000" }}
                  >
                    Product Variant
                  </InputLabel>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "10px",
                      marginTop: "10px",
                    }}
                  >
                    {optionNames.map((variant) => (
                      <div
                        style={{
                          border: "1.5px solid lightgray",
                          borderRadius: "8px",
                          width: "15%",
                          fontWeight: "bold",
                          color: "gray",
                          padding: "10px 0px",
                          textAlign: "center",
                          marginRight: "20px",
                          // marginTop:"10px"
                        }}
                      >
                        {variant.option}
                      </div>
                    ))}
                    <div style={{ width: "20%" }}>
                      {!isAdd ? (
                        <div
                          style={{
                            border: "1.5px dashed lightgray",
                            padding: "10px 15px",
                            borderRadius: "8px",
                            textAlign: "center",
                            width: "80%",
                            // marginTop: "10px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                          onClick={() => setIsAdd(!isAdd)}
                        >
                          <Add
                            style={{
                              fontWeight: "bold",
                              color: "gray",
                              marginRight: "5px",
                            }}
                          />
                          Add
                        </div>
                      ) : (
                        <InputField
                          placeholder="Enter Variant"
                          type="text"
                          style={{ marginTop: "0px" }}
                          size="small"
                          name="sku"
                          onKeyDown={(e) => {
                            if (e.key === "Enter") {
                              e.preventDefault();
                              setIsAdd(!isAdd);
                              setOptionNames([
                                ...optionNames,
                                {
                                  option: e.target.value,
                                },
                              ]);
                            }
                          }}
                          // defaultValue={variantDetails.sku}
                          // onChange={handleVariantDetails}
                        />
                      )}
                    </div>
                  </div>
                  <div style={{ marginTop: "40px", width: "100%" }}>
                    {optionNames.map((variant, i) => (
                      <div
                        key={i}
                        style={{
                          display: "flex",
                          alignItems: "center",
                          marginBottom: "20px",
                          width: "100%",
                        }}
                      >
                        <div style={{ width: "10%" }}>
                          <h6 style={{ fontWeight: 500 }}>{variant?.option}</h6>{" "}
                        </div>

                        <div style={{ width: "70%" }}>
                          <Autocomplete
                            sx={{ width: "100%" }}
                            multiple
                            id="tags-filled"
                            options={[]}
                            onChange={(event, value) =>
                              getVariants({
                                values: value,
                                option: variant.option,
                              })
                            }
                            // onChange={(event, value) =>
                            //   getVariants({ index: i, values: value, option:collection })
                            // }
                            defaultValue={variant?.values?.map(
                              (value) => value
                            )}
                            freeSolo
                            renderTags={(value, getTagProps) => {
                              return value?.map(
                                (option, index) =>
                                  option && (
                                    <Chip
                                      sx={{
                                        ".MuiAutocomplete-root &.MuiAutocomplete-tag":
                                          {
                                            margin: "5px",
                                            padding: "15px 0px",
                                            background: "#eee",
                                            borderRadius: "10px",
                                            border: "1px solid transparent",
                                          },
                                      }}
                                      variant="outlined"
                                      label={option || ""}
                                      {...getTagProps({ index })}
                                    />
                                  )
                              );
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                sx={{
                                  ".MuiOutlinedInput-root": {
                                    padding: "3px 0.80rem",
                                    ".Mui-active fieldset": {
                                      borderColor: "#fff",
                                    },
                                  },
                                }}
                              />
                            )}
                          />
                        </div>
                        <FiTrash
                          fontSize={20}
                          style={{ marginLeft: "20px", cursor: "pointer" }}
                          onClick={() => deleteVariant(variant.option)}
                        />
                      </div>
                    ))}
                  </div>
                </Grid>
                <Grid item xs={4}>
                  <InputLabel style={{ marginBottom: "10px" }}>
                    {" "}
                    Upload Sizing Table
                  </InputLabel>
                  {previewSizingTable && (
                    <div style={{ position: "relative" }}>
                      <img
                        src={previewSizingTable}
                        alt="sdfsd"
                        style={{
                          maxHeight: "280px",
                          width: "100%",
                          borderRadius: "8px",
                          objectFit: "cover",
                        }}
                      />
                      <div
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                        }}
                      >
                        <IconButton
                          style={{ color: "lightgray" }}
                          onChange={(e) => {
                            setSizingTableFileLink(e.target.files[0]);
                            setPreviewSizingTable(
                              URL.createObjectURL(e.target.files[0])
                            );
                          }}
                          //   color="primary"
                          aria-label="upload picture"
                          component="label"
                          // sx={{ position: "absolute", bottom: 10, right: 10 }}
                        >
                          <input hidden accept="image/*" type="file" />
                          <AddAPhoto sx={{ fontSize: "40px" }} />
                          {/* <Icon icon="bi:cloud-upload" width="40" height="40" /> */}
                        </IconButton>
                      </div>
                    </div>
                  )}
                  {!previewSizingTable && (
                    <div
                      style={{
                        height: "280px",
                        border: "1px dashed lightgray",
                        padding: "26px",
                        borderRadius: "5px",
                        display: "grid",
                        placeItems: "center",
                        // textAlign: "center",
                      }}
                    >
                      <IconButton
                        onChange={(e) => {
                          setSizingTableFileLink(e.target.files[0]);
                          setPreviewSizingTable(
                            URL.createObjectURL(e.target.files[0])
                          );
                        }}
                        //   color="primary"
                        aria-label="upload picture"
                        component="label"
                        // sx={{ position: "absolute", bottom: 10, right: 10 }}
                      >
                        <input hidden accept="image/*" type="file" />
                        <AddAPhoto sx={{ fontSize: "40px" }} />
                        {/* <Icon icon="bi:cloud-upload" width="40" height="40" /> */}
                      </IconButton>
                    </div>
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sx={{ marginTop: "20px" }}></Grid>
          </Grid>
        </Grid>
      </Grid>
    </div>
  );
}
